/**
 * Local storage names used in application
 */
export const SessionStorage = {
  ewUserToken: 'EW_USER_TOKEN',
  selectedUserDomain: 'EW_USER_DOMAIN',
};
